<template>
  <div>
    <h1 class="font-zeyada text-4xl my-4 text-center">Página no encontrada</h1>
  </div>
</template>
